import { useState } from 'react'
import AppleSignin from 'react-apple-signin-auth'
import { useMutation } from '@apollo/client/react'
import { Text } from '@mantine/core'
import appleLogo from '../img/apple-logo-white.svg'
import SocialLoginButton from './SocialLoginButton'
import LoginWithApple from '../graphql/queries/LoginWithApple'
import CurrentUser from '../graphql/queries/CurrentUser'
import { Actions } from '../AppReducer'
import { useAppDispatch } from '../AppContext'

export default function AppleLoginButton({ onClose, roomId }) {
    const dispatch = useAppDispatch()
    const [errorMessage, setErrorMessage] = useState('')
    const [loading, setLoading] = useState(false)

    const [loginWithApple] = useMutation(LoginWithApple, {
        fetchPolicy: 'no-cache',
        update: (cache, { data }) => {
            if (data?.loginWithApple) {
                cache.writeQuery({
                    query: CurrentUser,
                    data: data.loginWithApple
                })
            }
        }
    })

    async function handleSuccess(response) {
        setErrorMessage('')
        const idToken = response?.authorization?.id_token
        if (!idToken) {
            setErrorMessage('Apple sign-in failed. Please try again.')
            setLoading(false)
            return
        }
        try {
            const { data } = await loginWithApple({
                variables: { idToken }
            })
            if (data?.loginWithApple?.accessToken) {
                const { accessToken, refreshToken } = data.loginWithApple
                localStorage.setItem('at', accessToken)
                if (refreshToken) localStorage.setItem('rt', refreshToken)
                dispatch(Actions.logIn())
                if (roomId) dispatch(Actions.setCurrentRoom(roomId))
                onClose?.()
            }
        } catch (err) {
            console.error('Apple login error:', err)
            setErrorMessage('Apple sign-in failed. Please try again.')
        }
        setLoading(false)
    }

    function handleError(error) {
        // User closing the popup triggers an error — don't show a message for that
        if (error?.error === 'popup_closed_by_user') {
            setLoading(false)
            return
        }
        setErrorMessage('Apple sign-in failed. Please try again.')
        setLoading(false)
    }

    return (
        <>
            <AppleSignin
                authOptions={{
                    clientId: process.env.REACT_APP_APPLE_CLIENT_ID,
                    scope: 'email name',
                    redirectURI: process.env.REACT_APP_APPLE_REDIRECT_URI,
                    usePopup: true,
                }}
                onSuccess={handleSuccess}
                onError={handleError}
                render={(props) => (
                    <SocialLoginButton
                        {...props}
                        logo={appleLogo}
                        logoAlt="Apple"
                        loading={loading}
                        onClick={() => {
                            setLoading(true)
                            props.onClick()
                        }}
                    >
                        Continue with Apple
                    </SocialLoginButton>
                )}
            />
            {errorMessage && (
                <Text size="sm" c="red" ta="center" mt="xs">{errorMessage}</Text>
            )}
        </>
    )
}
